import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import classNames from "classnames";
import BannerHomeComponent from "../molecules/BannerHomeComponent/BannerHomeComponent";

// Removed intermediary section components (rendered later or removed)
//import Testimonials from "../molecules/Testimonials/Testimonials";
import ContactUs from "../molecules/ContactUs/ContactUs";
import ContactHelp from "../molecules/ContactHelp/ContactHelp";
import Footer from "../organisms/Footer/Footer";
// CompanyTextImage removed
import AppsFaq from "../molecules/AppsFaq/AppsFaq";
import CompanyStats from "../molecules/CompanyStats/CompanyStats";
import ProjectDisplay from "../molecules/ProjectDisplay/ProjectDisplay";
import { getPageData, useData } from "../../app/helper/functions";

// TheSattvaTechComponents removed
import ReadyYourBusiness from "../molecules/ReadyYourBusiness/ReadyYourBusiness";
import GalleryAtHome from "../molecules/GalleryAtHome/GalleryAtHome";
import ScalingProblemSection from "../molecules/ScalingProblemSection/ScalingProblemSection";
import CostOfDoingNothingSection from "../molecules/CostOfDoingNothingSection/CostOfDoingNothingSection";
import ThreeStepFrameworkSection from "../molecules/ThreeStepFrameworkSection/ThreeStepFrameworkSection";
import FounderTrustSection from "../molecules/FounderTrustSection/FounderTrustSection";
import WhoWeWorkWithSection from "../molecules/WhoWeWorkWithSection/WhoWeWorkWithSection";
import AppsTestimonials from "../molecules/AppsTestimonials/AppsTestimonials";
import SocialProofBar from "../molecules/SocialProofBar/SocialProofBar";
import PricingSignalSection from "../molecules/PricingSignalSection/PricingSignalSection";
import FinalCtaSection from "../molecules/FinalCtaSection/FinalCtaSection";
import WhySattvaTechSection from "../molecules/WhySattvaTechSection/WhySattvaTechSection";
import pageData from "../../app/utlis/firebaseConstants";


const HomePage = () => {
  const { data, loading } = useData();
  const homePageData = getPageData(data, 'HomePageData');
  const fadeUp = {
    initial: { opacity: 0, y: 80 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, margin: '-100px' },
    transition: { duration: 0.7, ease: 'easeIn' as const },
  };
  const [isHeroVideoReady, setIsHeroVideoReady] = useState(false);
  const [showInitialLoader, setShowInitialLoader] = useState(false);
  const [ismobile, setIsmobile] = useState(window.innerWidth < 768);
  const homeSectionRef = useRef<HTMLDivElement | null>(null);
  const Section1Ref = useRef<HTMLDivElement | null>(null);
  const Section2Ref = useRef<HTMLDivElement | null>(null);
  const Section3Ref = useRef<HTMLDivElement | null>(null);
  const Section4Ref = useRef<HTMLDivElement | null>(null);
  const Section5Ref = useRef<HTMLDivElement | null>(null);
  // Yellow dot ref
  const [yellowDotRef, setYellowDotRef] = useState({
    section0Dot1: useRef<HTMLDivElement | null>(null),
    section1Dot1: useRef<HTMLDivElement | null>(null),
    section2Dot: useRef<HTMLDivElement | null>(null),
    section3Dot1: useRef<HTMLDivElement | null>(null),
    section3Dot2: useRef<HTMLDivElement | null>(null),
    section3Dot3: useRef<HTMLDivElement | null>(null),
    section4Dot1: useRef<HTMLDivElement | null>(null),
    section5Dot1: useRef<HTMLDivElement | null>(null),
  });

  // Green dot ref
  const [greenDotRef, setGreenDotRef] = useState({
    section0Dot1: useRef<HTMLDivElement | null>(null),
    section1Dot1: useRef<HTMLDivElement | null>(null),
    section2Dot: useRef<HTMLDivElement | null>(null),
    section3Dot1: useRef<HTMLDivElement | null>(null),
    section3Dot2: useRef<HTMLDivElement | null>(null),
    section3Dot3: useRef<HTMLDivElement | null>(null),
    section4Dot1: useRef<HTMLDivElement | null>(null),
    section5Dot1: useRef<HTMLDivElement | null>(null),
  });
  // Green dot ref
  const [purpleDotRef, setPurpleDotRef] = useState({
    section0Dot1: useRef<HTMLDivElement | null>(null),
    section1Dot1: useRef<HTMLDivElement | null>(null),
    section2Dot: useRef<HTMLDivElement | null>(null),
    section3Dot1: useRef<HTMLDivElement | null>(null),
    section3Dot2: useRef<HTMLDivElement | null>(null),
    section3Dot3: useRef<HTMLDivElement | null>(null),
    section4Dot1: useRef<HTMLDivElement | null>(null),
    section5Dot1: useRef<HTMLDivElement | null>(null),
  });

  const [renderYellowDot, setRenderYellowDot] = useState(false);
  const [currentSection, setCurrentSection] = useState<number>(0);
  const [loadDot, setLoadDot] = useState(false);
  //  yellow dot
  const [yellowDotPoint, setYellowDotPoint] = useState([
    {
      top: "3.95%",
      left: "58.3%",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
  ]);
  const [yellowDot2Point, setYellowDot2Point] = useState([
    {
      top: "3.95%",
      left: "58.3%",
      scale: 1,
      classNames: "",
    },
    {
      top: "10%",
      left: "58.5%",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
  ]);
  const [yellowDot3Point, setYellowDot3Point] = useState([
    {
      top: "3.95%",
      left: "58.3%",
      scale: 1,
      classNames: "",
    },
    {
      top: "10%",
      left: "58.5%",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
  ]);

  //  Green Dot
  const [greenDotPoint, setGreenDotPoint] = useState([
    {
      top: "5.5%",
      left: "46.4%",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
  ]);
  const [greenDot2Point, setGreenDot2Point] = useState([
    {
      top: "5.5%",
      left: "46.4%",
      scale: 1,
      classNames: "!hidden",
    },
    {
      top: "10%",
      left: "58.5%",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
  ]);

  // Purple Dot
  const [purpleDotPoint, setPurpleDotPoint] = useState([
    {
      top: "6.7%",
      left: "34.3%",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "800.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
  ]);
  const [purpleDot2Point, setPurpleDot2Point] = useState([
    {
      top: "6.2%",
      left: "30.5%",
      scale: 1,
      classNames: "!hidden",
    },
    {
      top: "10%",
      left: "58.5%",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
    {
      top: "500.940px",
      left: "950.85687px",
      scale: 1,
      classNames: "",
    },
  ]);

  // to set position for all yellow dots
  useEffect(() => {
    setTimeout(() => {
      if (
        yellowDotRef.section0Dot1.current &&
        yellowDotRef.section1Dot1.current &&
        yellowDotRef.section3Dot1.current &&
        yellowDotRef.section3Dot2.current &&
        yellowDotRef.section3Dot3.current &&
        yellowDotRef.section2Dot.current &&
        yellowDotRef.section4Dot1.current &&
        yellowDotRef.section5Dot1.current
      ) {
        const yellowDot0 =
          yellowDotRef.section0Dot1.current.getBoundingClientRect();
        const yellowDot1 =
          yellowDotRef.section1Dot1.current.getBoundingClientRect();
        const section2yellowDot =
          yellowDotRef.section2Dot.current.getBoundingClientRect();
        const section3yellowDot1 =
          yellowDotRef.section3Dot1.current.getBoundingClientRect();
        const section3yellowDot2 =
          yellowDotRef.section3Dot2.current.getBoundingClientRect();
        const section3yellowDot3 =
          yellowDotRef.section3Dot3.current.getBoundingClientRect();
        const section4yellowDot1 =
          yellowDotRef.section4Dot1.current.getBoundingClientRect();
        const section5yellowDot1 =
          yellowDotRef.section5Dot1.current.getBoundingClientRect();
        setYellowDotPoint((pre) => {
          pre[0] = {
            top: `${yellowDot0.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : yellowDot0.left}px`,
            classNames: `w-20 h-20 rounded-full z-10 !top-[${yellowDot0.top + window.scrollY}px] !left-[${ismobile ? Math.round(window.innerWidth / 2) : Math.round(yellowDot0.left)}px]`,
            scale: 1,
          };
          pre[1] = {
            top: `${yellowDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : yellowDot1.left}px`,
            classNames: `!scale-y-[60%] -rotate-[20deg] !w-8 !h-8 ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[2] = {
            top: `${section2yellowDot.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section2yellowDot.left}px`,
            classNames: `!w-14 !h-14 !transform !block ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[3] = {
            top: `${section3yellowDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section3yellowDot1.left}px`,
            classNames: `!scale-y-[60%] -rotate-[20deg] !w-12 !h-12 ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[4] = {
            top: `${section4yellowDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section4yellowDot1.left}px`,
            classNames: `!w-14 !h-14 !transform translate-x-[2px] !block ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[5] = {
            top: `${section5yellowDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section5yellowDot1.left}px`,
            classNames: `!w-16 !h-16 !transform translate-x-[0px] !block ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          return pre;
        });
        setYellowDot2Point((pre) => {
          pre[0] = {
            top: `${yellowDot0.top + window.scrollY}px`,
            left: `${yellowDot0.left}px`,
            classNames: "w-20 h-20 rounded-full z-10",
            scale: 0.7,
          };
          pre[1] = {
            top: `${yellowDot1.top + window.scrollY}px`,
            left: `${yellowDot1.left}px`,
            classNames: "!scale-y-[60%] -rotate-[20deg] !w-8 !h-8 ",
            scale: 0.7,
          };
          pre[2] = {
            top: `${section2yellowDot.top + window.scrollY}px`,
            left: `${section2yellowDot.left}px`,
            classNames: "!w-14 !h-14 !transform",
            scale: 0.7,
          };
          pre[3] = {
            top: `${section3yellowDot2.top + window.scrollY}px`,
            left: `${section3yellowDot2.left}px`,
            classNames: "!scale-y-[60%] -rotate-[20deg] !w-12 !h-12 !block",
            scale: 0.7,
          };
          pre[4] = {
            top: `${section4yellowDot1.top + window.scrollY}px`,
            left: `${section4yellowDot1.left}px`,
            classNames: "!w-14 !h-14 !transform translate-x-[2px] !block",
            scale: 0.7,
          };
          pre[5] = {
            top: `${section5yellowDot1.top + window.scrollY}px`,
            left: `${section5yellowDot1.left}px`,
            classNames: "!w-16 !h-16 !transform translate-x-[0px] !block",
            scale: 0.7,
          };
          return pre;
        });
        setYellowDot3Point((pre) => {
          pre[0] = {
            top: `${yellowDot0.top + window.scrollY}px`,
            left: `${yellowDot0.left}px`,
            classNames: "w-20 h-20 rounded-full z-10",
            scale: 0.7,
          };
          pre[1] = {
            top: `${yellowDot1.top + window.scrollY}px`,
            left: `${yellowDot1.left}px`,
            classNames: "!scale-y-[60%] -rotate-[20deg] !w-8 !h-8 ",
            scale: 0.7,
          };
          pre[2] = {
            top: `${section2yellowDot.top + window.scrollY}px`,
            left: `${section2yellowDot.left}px`,
            classNames: "!w-14 !h-14 !transform !block",
            scale: 0.7,
          };
          pre[3] = {
            top: `${section3yellowDot3.top + window.scrollY}px`,
            left: `${section3yellowDot3.left}px`,
            classNames: "!scale-y-[60%] -rotate-[20deg] !w-12 !h-12 !block",
            scale: 0.7,
          };
          pre[4] = {
            top: `${section4yellowDot1.top + window.scrollY}px`,
            left: `${section4yellowDot1.left}px`,
            classNames: "!w-14 !h-14 !transform translate-x-[2px] !block",
            scale: 0.7,
          };
          pre[5] = {
            top: `${section5yellowDot1.top + window.scrollY}px`,
            left: `${section5yellowDot1.left}px`,
            classNames: "!w-16 !h-16 !transform translate-x-[0px] !block",
            scale: 0.7,
          };
          return pre;
        });
        setRenderYellowDot(true);
        setTimeout(() => {
          setLoadDot(true);
        }, 50);
      }
    }, 300);
  }, [ismobile]);


  // to set position for all green dots
  useEffect(() => {
    setTimeout(() => {
      if (
        greenDotRef.section0Dot1.current &&
        greenDotRef.section1Dot1.current &&
        greenDotRef.section3Dot1.current &&
        greenDotRef.section3Dot2.current &&
        greenDotRef.section2Dot.current &&
        greenDotRef.section4Dot1.current &&
        greenDotRef.section5Dot1.current
      ) {
        const greenDot0 =
          greenDotRef.section0Dot1.current.getBoundingClientRect();
        const greenDot1 =
          greenDotRef.section1Dot1.current.getBoundingClientRect();
        const section2greenDot =
          greenDotRef.section2Dot.current.getBoundingClientRect();
        const section3greenDot1 =
          greenDotRef.section3Dot1.current.getBoundingClientRect();
        const section3greenDot2 =
          greenDotRef.section3Dot2.current.getBoundingClientRect();
        const section4greenDot1 =
          greenDotRef.section4Dot1.current.getBoundingClientRect();
        const section5greenDot1 =
          greenDotRef.section5Dot1.current.getBoundingClientRect();
        setGreenDotPoint((pre) => {
          pre[0] = {
            top: `${greenDot0.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : greenDot0.left}px`,
            classNames: `!w-20 !h-20 !transform !orange-bg ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.1,
          };
          pre[1] = {
            top: `${greenDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : greenDot1.left}px`,
            classNames: `!scale-y-[60%] -rotate-[20deg] !w-20 !h-20 !transform translate-x-[6px] !orange-bg ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[2] = {
            top: `${section2greenDot.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section2greenDot.left}px`,
            classNames: `!w-14 !h-14 !transform !block !orange-bg ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[3] = {
            top: `${section3greenDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section3greenDot1.left}px`,
            classNames: `!scale-y-[60%] -rotate-[20deg] !w-12 !h-12 ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[4] = {
            top: `${section4greenDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section4greenDot1.left}px`,
            classNames: `!w-14 !h-14 !transform translate-x-[2px] !block ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[5] = {
            top: `${section5greenDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section5greenDot1.left}px`,
            classNames: `!w-16 !h-16 !transform translate-x-[0px] !block ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          return pre;
        });
        setGreenDot2Point((pre) => {
          pre[1] = {
            top: `${greenDot1.top + window.scrollY}px`,
            left: `${greenDot1.left}px`,
            classNames:
              "!scale-y-[60%] -rotate-[20deg] !w-20 !h-20 !transform translate-x-[6px]",
            scale: 0.7,
          };
          pre[2] = {
            top: `${section2greenDot.top + window.scrollY}px`,
            left: `${section2greenDot.left}px`,
            classNames: "!w-14 !h-14 !transform !block !orange-bg",
            scale: 0.7,
          };
          pre[3] = {
            top: `${section3greenDot2.top + window.scrollY}px`,
            left: `${section3greenDot2.left}px`,
            classNames: "!scale-y-[60%] -rotate-[20deg] !w-12 !h-12 ",
            scale: 0.7,
          };
          pre[4] = {
            top: `${section4greenDot1.top + window.scrollY}px`,
            left: `${section4greenDot1.left}px`,
            classNames: "!w-14 !h-14 !transform translate-x-[2px] ",
            scale: 0.7,
          };
          pre[5] = {
            top: `${section5greenDot1.top + window.scrollY}px`,
            left: `${section5greenDot1.left}px`,
            classNames: "!w-16 !h-16 !transform translate-x-[0px] ",
            scale: 0.7,
          };
          return pre;
        });
      }
    }, 300);
  }, [ismobile]);
  // to set position for all purple dots
  useEffect(() => {
    setTimeout(() => {
      if (
        purpleDotRef.section0Dot1.current &&
        purpleDotRef.section1Dot1.current &&
        purpleDotRef.section3Dot1.current &&
        purpleDotRef.section3Dot2.current &&
        purpleDotRef.section2Dot.current &&
        purpleDotRef.section4Dot1.current &&
        purpleDotRef.section5Dot1.current
      ) {
        const purpleDot0 =
          purpleDotRef.section0Dot1.current.getBoundingClientRect();
        const purpleDot1 =
          purpleDotRef.section1Dot1.current.getBoundingClientRect();
        const section2PurpleDot =
          purpleDotRef.section2Dot.current.getBoundingClientRect();
        const section3purpleDot1 =
          purpleDotRef.section3Dot1.current.getBoundingClientRect();
        const section3purpleDot2 =
          purpleDotRef.section3Dot2.current.getBoundingClientRect();
        const section4purpleDot1 =
          purpleDotRef.section4Dot1.current.getBoundingClientRect();
        const section5purpleDot1 =
          purpleDotRef.section5Dot1.current.getBoundingClientRect();
        setPurpleDotPoint((pre) => {
          pre[0] = {
            top: `${purpleDot0.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : purpleDot0.left}px`,
            classNames: `!bg-purple ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 1,
          };
          pre[1] = {
            top: `${purpleDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : purpleDot1.left}px`,
            classNames: `!scale-y-[60%] -rotate-[33deg] !w-8 !h-8 !bg-purple ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[2] = {
            top: `${section2PurpleDot.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section2PurpleDot.left}px`,
            classNames: `!w-14 !h-14 !transform !block !bg-purple !z-0 ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[3] = {
            top: `${section3purpleDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section3purpleDot1.left}px`,
            classNames: `!scale-y-[60%] -rotate-[20deg] !w-12 !h-12 ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[4] = {
            top: `${section4purpleDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section4purpleDot1.left}px`,
            classNames: `!w-14 !h-14 !transform translate-x-[2px] !block ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          pre[5] = {
            top: `${section5purpleDot1.top + window.scrollY}px`,
            left: `${ismobile ? window.innerWidth / 2 : section5purpleDot1.left}px`,
            classNames: `!w-16 !h-16 !transform translate-x-[0px] !block ${ismobile ? '!left-[' + Math.round(window.innerWidth / 2) + 'px]' : ''}`,
            scale: 0.7,
          };
          return pre;
        });
        setPurpleDot2Point((pre) => {
          pre[1] = {
            top: `${purpleDot1.top + window.scrollY}px`,
            left: `${purpleDot1.left}px`,
            classNames: "!scale-y-[60%] -rotate-[33deg] !w-8 !h-8",
            scale: 0.7,
          };
          pre[2] = {
            top: `${section2PurpleDot.top + window.scrollY}px`,
            left: `${section2PurpleDot.left}px`,
            classNames: "!w-14 !h-14 !transform !bg-purple !z-0",
            scale: 0.7,
          };
          pre[3] = {
            top: `${section3purpleDot2.top + window.scrollY}px`,
            left: `${section3purpleDot2.left}px`,
            classNames: "!scale-y-[60%] -rotate-[20deg] !w-12 !h-12 !block",
            scale: 0.7,
          };
          pre[4] = {
            top: `${section4purpleDot1.top + window.scrollY}px`,
            left: `${section4purpleDot1.left}px`,
            classNames: "!w-14 !h-14 !transform translate-x-[2px] !block",
            scale: 0.7,
          };
          pre[5] = {
            top: `${section5purpleDot1.top + window.scrollY}px`,
            left: `${section5purpleDot1.left}px`,
            classNames: "!w-16 !h-16 !transform translate-x-[0px] !block",
            scale: 0.7,
          };
          return pre;
        });
      }
    }, 300);
  }, []);

  // observer
  useEffect(() => {
    let homeSectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.8) {
          setCurrentSection(0);
        }
      },
      {
        threshold: 0.8,
      }
    );
    let section1Observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.8) {
          setCurrentSection(1);
        }
      },
      {
        threshold: 0.8,
      }
    );

    let section2Observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.8) {
          setCurrentSection(2);
        }
      },
      {
        threshold: 0.8,
      }
    );
    let section3Observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.8) {
          setCurrentSection(3);
        }
      },
      {
        threshold: 0.8,
      }
    );
    let section4Observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.8) {
          setCurrentSection(4);
        }
      },
      {
        threshold: 0.8,
      }
    );
    let section5Observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.6) {
          setCurrentSection(5);
        }
      },
      {
        threshold: 0.6,
      }
    );

    if (homeSectionRef.current)
      homeSectionObserver.observe(homeSectionRef.current);
    if (Section1Ref.current) section1Observer.observe(Section1Ref.current);
    if (Section2Ref.current) section2Observer.observe(Section2Ref.current);
    if (Section3Ref.current) section3Observer.observe(Section3Ref.current);
    if (Section4Ref.current) section4Observer.observe(Section4Ref.current);
    if (Section5Ref.current) section5Observer.observe(Section5Ref.current);

    return () => {
      if (homeSectionRef.current)
        homeSectionObserver.unobserve(homeSectionRef.current);
      if (Section1Ref.current) section1Observer.unobserve(Section1Ref.current);
      if (Section2Ref.current) section2Observer.unobserve(Section2Ref.current);
      if (Section3Ref.current) section3Observer.unobserve(Section3Ref.current);
      if (Section4Ref.current) section4Observer.unobserve(Section4Ref.current);
      if (Section5Ref.current) section5Observer.unobserve(Section5Ref.current);
    };
  }, []);

  // Add window resize handler
  useEffect(() => {
    const handleResize = () => {
      setIsmobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const hasVisited = window.localStorage.getItem("home_loader_seen");
    if (!hasVisited) {
      setShowInitialLoader(true);
    }
  }, []);

  useEffect(() => {
    if (!showInitialLoader) return;

    const fallbackTimeout = window.setTimeout(() => {
      setShowInitialLoader(false);
      window.localStorage.setItem("home_loader_seen", "true");
    }, 5000);

    return () => window.clearTimeout(fallbackTimeout);
  }, [showInitialLoader]);

  useEffect(() => {
    if (!showInitialLoader) return;
    if (loading || !isHeroVideoReady) return;

    const hideLoaderTimeout = window.setTimeout(() => {
      setShowInitialLoader(false);
      window.localStorage.setItem("home_loader_seen", "true");
    }, 450);

    return () => window.clearTimeout(hideLoaderTimeout);
  }, [loading, isHeroVideoReady, showInitialLoader]);

  return (
    <div className="relative">
      {showInitialLoader && (
        <div className="fixed inset-0 z-[2000] bg-[#141414] flex items-center justify-center">
          <div className="flex items-center gap-3">
            <span
              className="h-3.5 w-3.5 rounded-full bg-[#229CFF] animate-bounce"
              style={{ animationDelay: "0ms", animationDuration: "800ms" }}
            />
            <span
              className="h-3.5 w-3.5 rounded-full bg-[#ED943C] animate-bounce"
              style={{ animationDelay: "120ms", animationDuration: "800ms" }}
            />
            <span
              className="h-3.5 w-3.5 rounded-full bg-[#5A47F9] animate-bounce"
              style={{ animationDelay: "240ms", animationDuration: "800ms" }}
            />
          </div>
        </div>
      )}
      {/* yellow dots */}
      {!ismobile && (
        <>
          <div
            className={`absolute top-[1.85%] left-[55%] p-4 bg-[#229CFF10] rounded-full flex items-center justify-center z-30`}
          >
            <div className="p-4 bg-[#229CFF30] rounded-full flex items-center justify-center z-30">
              <div className="p-4 bg-[#229CFF20] rounded-full flex items-center justify-center z-30">
                <div
                  className={classNames(
                    `w-20 h-20 rounded-full flex items-center justify-center bg-transparent z-30`
                  )}
                  ref={yellowDotRef.section0Dot1}
                ></div>
              </div>
            </div>
          </div>
          {loadDot && (
            <>
              <motion.div
                className={classNames(
                  `absolute w-20 h-20 top-[2.55%] left-[58.5%] rounded-full flex items-center justify-center bg-yellow z-20 `,
                  yellowDotPoint[currentSection].classNames
                )}
                animate={loadDot ? { ...yellowDotPoint[currentSection] } : {}}
                transition={{ duration: 1 }}
              ></motion.div>
              <>
                <motion.div
                  className={classNames(
                    `absolute top-[3.95%] left-[58.3%] w-20 h-20 rounded-full flex items-center justify-center bg-yellow z-10`,
                    yellowDot3Point[currentSection].classNames
                  )}
                  animate={yellowDot3Point[currentSection]}
                  transition={{ duration: 1 }}
                ></motion.div>
                <motion.div
                  className={classNames(
                    `absolute top-[3.95%] left-[58.3%] w-20 h-20 rounded-full flex items-center justify-center bg-yellow `,
                    yellowDot2Point[currentSection].classNames
                  )}
                  animate={yellowDot2Point[currentSection]}
                  transition={{ duration: 1 }}
                ></motion.div>
              </>
            </>
          )}

          {/* green dots */}
          <div
            style={{ background: 'linear-gradient(118.8deg, rgba(237, 148, 60, 0.1) 27.32%, rgba(231, 54, 54, 0.1) 91.18%)' }}
            className={`absolute top-[3%] left-[43.2%] p-4 rounded-full flex items-center justify-center z-20`}
          >
            <div style={{ background: 'linear-gradient(118.8deg, rgba(237, 148, 60, 0.2) 27.32%, rgba(231, 54, 54, 0.2) 91.18%)' }} className="p-4 rounded-full flex items-center justify-center z-10">
              <div style={{ background: 'linear-gradient(118.8deg, rgba(237, 148, 60, 0.3) 27.32%, rgba(231, 54, 54, 0.3) 91.18%)' }} className="p-4 rounded-full flex items-center justify-center z-10">
                <div
                  className={classNames(
                    `w-20 h-20 rounded-full flex items-center justify-center bg-transparent z-10`
                  )}
                  ref={greenDotRef.section0Dot1}
                ></div>
              </div>
            </div>
          </div>
          {loadDot && (
            <>
              <>
                <motion.div
                  transition={{ duration: 1 }}
                  className={classNames(
                    `absolute top-[3.5%] left-[46.4%] w-20 h-20 rounded-full orange-bg z-20 `,
                    greenDotPoint[currentSection].classNames
                  )}
                  animate={greenDotPoint[currentSection]}
                ></motion.div>
              </>
              {
                <>
                  <motion.div
                    transition={{ duration: 1 }}
                    className={classNames(
                      `absolute w-20 h-20 rounded-full orange-bg z-10 `,
                      greenDot2Point[currentSection].classNames
                    )}
                    animate={greenDot2Point[currentSection]}
                  ></motion.div>
                </>
              }
            </>
          )}

          {/* purple dot */}
          <div
            className={`absolute top-[4.2%] left-[31%] p-4 bg-[#5A47F910] rounded-full z-20 flex items-center justify-center`}
          >
            <div className="p-4 bg-[#5A47F930] rounded-full flex items-center justify-center z-10">
              <div className="p-4 bg-[#5A47F920] rounded-full flex items-center justify-center z-10">
                <div
                  className={classNames(
                    `w-20 h-20 rounded-full z-20 flex items-center justify-center bg-transparent`
                  )}
                  ref={purpleDotRef.section0Dot1}
                ></div>
              </div>
            </div>
          </div>

          {loadDot && (
            <>
              <>
                <motion.div
                  transition={{ duration: 1 }}
                  className={classNames(
                    `absolute top-[4.7%] left-[34.3%] w-20 h-20 rounded-full bg-purple z-20 `,
                    purpleDotPoint[currentSection].classNames
                  )}
                  animate={purpleDotPoint[currentSection]}
                ></motion.div>
              </>
              {
                <>
                  <motion.div
                    transition={{ duration: 1 }}
                    className={classNames(
                      `absolute w-20 h-20 rounded-full bg-purple z-10 `,
                      purpleDot2Point[currentSection].classNames
                    )}
                    animate={purpleDot2Point[currentSection]}
                  ></motion.div>
                </>
              }
            </>
          )}
        </>
      )}

      <div ref={homeSectionRef}>
        <BannerHomeComponent
          homePageData={homePageData}
          onVideoReady={() => setIsHeroVideoReady(true)}
        />
      </div>

      {/* <SocialProofBar data={homePageData?.socialProofBar} /> */}

      <div className="bg-[#171717] overflow-visible">

        <motion.div {...fadeUp}>
          <CompanyStats
            yellowRef={yellowDotRef.section4Dot1}
            greenRef={greenDotRef.section4Dot1}
            purpleRef={purpleDotRef.section4Dot1}
            data={homePageData?.companyStats}
          />
        </motion.div>

        <motion.div {...fadeUp}>
          <ScalingProblemSection data={homePageData?.scalingProblemSection}/>
        </motion.div>
        <motion.div {...fadeUp}>
          <WhoWeWorkWithSection data={homePageData?.whoWeWorkWithSection} />
        </motion.div>
        <motion.div {...fadeUp}>
          {/* Projects displayed immediately after stats */}
          {/* <ProjectDisplay data={homePageData?.projectSection} /> */}
        </motion.div>
        <motion.div {...fadeUp}>
          <CostOfDoingNothingSection data={homePageData?.costOfDoingNothingSection} />
        </motion.div>
        <motion.div {...fadeUp}>
          <ThreeStepFrameworkSection data={homePageData?.threeStepFrameworkSection} />
        </motion.div>
        <motion.div {...fadeUp}>
          <FounderTrustSection data={homePageData?.founderTrustSection} />
        </motion.div>

        <motion.div {...fadeUp}>
          <WhySattvaTechSection  />
        </motion.div>
        {/* <motion.div {...fadeUp}>
          <AppsTestimonials
            color="#2396EE"
            bgcolor="bg-[#2396EE]"
            textColor="black"
            activeTextColor="white"
            bgUnActiveColor="bg-blackDarkThemePrimary"
            sliderColor="#2e2e2e"
          />
        </motion.div> */}
        {/* <motion.div {...fadeUp}>
          <PricingSignalSection data={homePageData?.pricingSignalSection} />
        </motion.div> */}
        {/* <motion.div {...fadeUp}>
          <FinalCtaSection data={homePageData?.finalCtaSection} />
        </motion.div> */}
        {/* <Portfolio /> */}
        {/* <Faqs /> */}
        {/* <motion.div {...fadeUp}>
          <ReadyYourBusiness data={homePageData?.readyYourBusinessSection} />
        </motion.div>
        <motion.div {...fadeUp}>
          <GalleryAtHome data={homePageData?.gallerySection} />
        </motion.div> */}
        <motion.div {...fadeUp}>
          <AppsFaq data={homePageData?.faqSection} />
        </motion.div>
        <motion.div {...fadeUp}>
          <ContactUs data={homePageData?.contactUsSection} />
        </motion.div>
        {/* <motion.div {...fadeUp}>
          <ContactHelp
            title={homePageData?.contactHelpSection?.title || "Need help locating us?"}
            buttonTitle={homePageData?.contactHelpSection?.buttonTitle || "CONTACT US"}
          />
        </motion.div>
        <motion.div {...fadeUp}>
          <Footer footerContactInfo />
        </motion.div> */}
        {/* <SubmitForm /> */}
        <Footer />
        <div></div>
      </div>
    </div>
  );
};

export default HomePage;
